module.exports = __webpack_public_path__ + "img/settings_240.a2d4bf8d.png";